const useAuth = () => {
  return {
    isLogin: !!localStorage.getItem("token"),
  };
};

export default useAuth;
